/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 出血の種類
 */
export type FindEmsContactBleedingTypeEnum =
  (typeof FindEmsContactBleedingTypeEnum)[keyof typeof FindEmsContactBleedingTypeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FindEmsContactBleedingTypeEnum = {
  NONE: 'NONE',
  EXTERNAL_HEMORRHAGE: 'EXTERNAL_HEMORRHAGE',
  HEMATEMESIS: 'HEMATEMESIS',
  HEMOPTYSIS: 'HEMOPTYSIS',
  LOWER_GI_BLEEDING: 'LOWER_GI_BLEEDING',
  GENITAL_HEMORRHAGE: 'GENITAL_HEMORRHAGE',
  SUBCUTANEOUS_HEMORRHAGE: 'SUBCUTANEOUS_HEMORRHAGE',
  EPISTAXIS: 'EPISTAXIS',
  EXTERNAL_BLEEDING_ARTERIAL_HEAVY: 'EXTERNAL_BLEEDING_ARTERIAL_HEAVY',
  EXTERNAL_BLEEDING_ARTERIAL_LIGHT: 'EXTERNAL_BLEEDING_ARTERIAL_LIGHT',
  EXTERNAL_BLEEDING_VENOUS_HEAVY: 'EXTERNAL_BLEEDING_VENOUS_HEAVY',
  EXTERNAL_BLEEDING_VENOUS_LIGHT: 'EXTERNAL_BLEEDING_VENOUS_LIGHT',
  EXTERNAL_BLEEDING_CAPILLARY: 'EXTERNAL_BLEEDING_CAPILLARY',
  NOSEBLEED_HEAVY: 'NOSEBLEED_HEAVY',
  NOSEBLEED_LIGHT: 'NOSEBLEED_LIGHT',
  EAR_BLEEDING_HEAVY: 'EAR_BLEEDING_HEAVY',
  EAR_BLEEDING_LIGHT: 'EAR_BLEEDING_LIGHT',
  OTHER: 'OTHER',
} as const;
